import type { ReactNode } from "react";

export const FormSection = ({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: ReactNode;
}) => (
  <section className="space-y-6">
    <div className="space-y-1">
      <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
      {description && <p className="max-w-3xl text-sm text-gray-500">{description}</p>}
    </div>
    {children}
  </section>
);

export const FormFooter = ({ children, justify = "between" }: { children: ReactNode; justify?: "between" | "end" }) => (
  <div
    className={`
      flex items-center gap-3 pt-2
      ${justify === "between" ? "justify-between" : "justify-end"}
    `}
  >
    {children}
  </div>
);

export const Divider = () => <div className="h-px w-full bg-gray-200" />;

export const ReadOnlyFormValue = ({ label, value }: { label: string; value: string }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700">{label}</label>
    <div className="mt-1 w-full rounded-md border border-gray-300 bg-gray-50 px-3 py-2 text-sm text-gray-500 shadow-sm">
      {value}
    </div>
  </div>
);
